import { FC, memo, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { AccessDenied } from '../access-denied';
import { Spinner } from '../spinner';
import styles from './protected-route.module.css';

type ProtectedRouteProps = {
  isValid: boolean;
  isLoading: boolean;
  isError: boolean;
  children: ReactNode;
};

export const ProtectedRoute: FC<ProtectedRouteProps> = memo(
  ({ isValid, isLoading, isError, children }) => {
    const { t } = useTranslation('translation', {
      keyPrefix: 'ui.protectedRoute',
    });

    if (isLoading) {
      return (
        <div className={styles.main}>
          <Spinner size="50px" />
        </div>
      );
    }

    if (isError) {
      return (
        <div className={styles.main}>
          <div className={styles.error}>{t('error')}</div>
        </div>
      );
    }

    if (!isValid) {
      return (
        <div className={styles.main}>
          <AccessDenied />
        </div>
      );
    }

    return children;
  },
);

export default ProtectedRoute;
